export const bicyclePedestrianEditComponent = {

    //passing title and onSubmit function for binding in main component
    template: `
                <bicycle-pedestrian-main
                    page-title='Edit'
                    details='$ctrl.details'
                    parent-slug='{{$ctrl.parentSlug}}'
                    disable-buttons='$ctrl.disableButtons'
                    on-submit='$ctrl.onSubmit(details)'
                    county='$ctrl.county'>
                </bicycle-pedestrian-main>`,

    bindings: {
        details: '<',
        parentSlug: '@',
        slugUrl: '@'
    },

    //controller for BicyclePedestrianEditComponent
    controller: class BicyclePedestrianEditComponent {
        constructor(toastr, $state, $stateParams, TransportationAlternativeService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            this.toastr = toastr;
            this.$state = $state;
            this.$stateParams = $stateParams;
            this.transportationAlternativeService = TransportationAlternativeService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        //storing old data in savedData
        $onInit() {
            this.county = [];
            this.details = this.transportationAlternativeService.getBicyclePedestrianDetailsById(this.details);
            this.savedData = angular.copy(this.details);
            this._getCountyList();
        }

        //comparing old and new data for update on submit function
        onSubmit(details) {
            const _details = angular.copy(details);
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, _details, true);
            if (isUpdated) {
                const url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
                const details = this.transportationAlternativeService._setTemplate2DetailObject(_details);

                this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, details)
                    .then((details) => {
                        const contentDetailsUrl = this.slugService.getDetailsPageURL(url);
                        this.toastr.success('Data updated successfully');
                        this._redirectToParentState(contentDetailsUrl);
                        this.disableButtons = false;
                    }).catch((err) => {
                        this.toastr.error(err);
                        this._redirectToParentState(this.parentSlug);
                        this.disableButtons = false
                    });
            } else {
                this.toastr.success('Nothing to update');
                this.disableButtons = false;
            }
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }

        _getCountyList() {
            this.transportationAlternativeService.getCountyList()
                .then(county => this.county = county);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/transportation-alternative/bicycle-pedestrian/bicycle-pedestrian-edit/bicycle-pedestrian-edit.component.js